import React, { Component } from "react";
import { connect } from "react-redux";
import { mountTabulatorReduce } from "../actions";
import { connection_platform } from "../services/api";
import axios from "axios";

var port = localStorage.getItem("port");
var pathname = localStorage.getItem("pathname");

const mapStateToProps = (state) => {
  return {
    InfoUsers: state.informationusers,
  };
};

const mapDispatchToProps = (dispatch) => ({
  mountTabulatorReduce: (array) => {
    dispatch(mountTabulatorReduce(array));
  },
});

class MountTabulator extends Component {
  constructor(props) {
    super(props);
    this.state = { user: props.InfoUsers ? props.InfoUsers : "" };
  }

  async getSubcategoryTree(
    idfather,
    namefather,
    primaryPath = "",
    primaryPathIds = "",
  ) {
    const { user } = this.state;
    let aux = idfather;
    let temp = true;
    let children = [];
    try {
      while (temp) {
        const retorno = await axios.get(
          `${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfathersec?groupid=${user.idgroup}&idfather=${aux}`,
        );
        if (retorno.status === 200) {
          let data = retorno.data;
          if (data.length !== 0) {
            temp = true;
            for (let i = 0; i < data.length; i++) {
              const path = `${primaryPath} > ${data[i].desc_subcat}`;
              const pathId = `${primaryPathIds}&${data[i].subcatid}`;
              const id = pathId;
              if (aux !== data[i].subcatid) {
                let getSubcat = await this.getSubcategoryTree(
                  data[i].subcatid,
                  data[i].desc_subcat,
                  path,
                  pathId,
                  id,
                );
                if (getSubcat.length !== 0) {
                  children.push({
                    value: data[i].subcatid,
                    label: data[i].desc_subcat,
                    children: getSubcat,
                    className: "dropdownd-three-childrens",
                    path,
                    pathId,
                    id,
                  });
                } else {
                  children.push({
                    value: data[i].subcatid,
                    label: data[i].desc_subcat,
                    path,
                    pathId,
                    id,
                  });
                }
              } else {
                children[children.length - 1].children.push({
                  value: data[i].subcatid,
                  label: data[i].desc_subcat,
                  path,
                  pathId,
                  id,
                });
              }
              aux = data[i].subcatid;
            }
          } else {
            temp = false;
          }
        }
      }
    } catch (error) {
      console.log("ERRO_TABULATOR : ", error);
    }

    return children;
  }

  // async componentDidMount() {
  //   port = localStorage.getItem("port");
  //   pathname = localStorage.getItem("pathname");

  //   const { user } = this.state;

  //   if (user.idgroup !== undefined) {
  //     const retorno = await axios.get(
  //       `${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfatherpri?groupid=${user.idgroup}`,
  //     );

  //     let array = [];
  //     let data = retorno.data;
  //     let categoryid = 0;
  //     if (data.length !== 0) {
  //       for (let i = 0; i < data.length; i++) {
  //         const rootPath = data[i].desc_category;
  //         const rootPathIds = `${data[i].categoryid}`;
  //         const primaryPath = `${rootPath} > ${data[i].desc_subcat}`;
  //         const primaryPathIds = `${rootPathIds}&${data[i].subcatid}`;

  //         if (categoryid !== data[i].categoryid) {
  //           let getSubcat = await this.getSubcategoryTree(
  //             data[i].subcatid,
  //             data[i].desc_subcat,
  //             primaryPath,
  //             primaryPathIds,
  //           );
  //           if (getSubcat.length !== 0) {
  //             array.push({
  //               value: data[i].categoryid,
  //               label: data[i].desc_category,
  //               path: rootPath,
  //               pathId: rootPathIds,
  //               id: rootPathIds,
  //               className: "dropdownd-three-childrens",
  //               children: [
  //                 {
  //                   value: data[i].subcatid,
  //                   label: data[i].desc_subcat,
  //                   className: "dropdownd-three-childrens",
  //                   children: getSubcat,
  //                   path: primaryPath,
  //                   pathId: primaryPathIds,
  //                   id: primaryPathIds,
  //                 },
  //               ],
  //             });
  //           } else {
  //             array.push({
  //               value: data[i].categoryid,
  //               label: data[i].desc_category,
  //               path: rootPath,
  //               pathId: rootPathIds,
  //               id: rootPathIds,
  //               className: "dropdownd-three-childrens",
  //               children: [
  //                 {
  //                   value: data[i].subcatid,
  //                   label: data[i].desc_subcat,
  //                   path: primaryPath,
  //                   pathId: primaryPathIds,
  //                   id: primaryPathIds,
  //                 },
  //               ],
  //             });
  //           }
  //         } else {
  //           let getSubcat = await this.getSubcategoryTree(
  //             data[i].subcatid,
  //             data[i].desc_subcat,
  //             primaryPath,
  //             primaryPathIds,
  //           );
  //           if (getSubcat.length !== 0) {
  //             array[array.length - 1].children.push({
  //               value: data[i].subcatid,
  //               label: data[i].desc_subcat,
  //               path: primaryPath,
  //               children: getSubcat,
  //               className: "dropdownd-three-childrens",
  //               pathId: primaryPathIds,
  //               id: primaryPathIds,
  //             });
  //           } else {
  //             array[array.length - 1].children.push({
  //               value: data[i].subcatid,
  //               label: data[i].desc_subcat,
  //               path: primaryPath,
  //               pathId: primaryPathIds,
  //               id: primaryPathIds,
  //             });
  //           }
  //         }
  //         categoryid = data[i].categoryid;
  //       }
  //     }
  //     console.log("raimundo_neto 198", { array });
  //     this.props.mountTabulatorReduce(array);
  //   }
  // }

  async componentDidMount() {
    port = localStorage.getItem("port");
    pathname = localStorage.getItem("pathname");

    const createChildren = (path, pathId, children) => {
      return children.map((child) => {
        const hasChildren =
          Array.isArray(child.children) && child.children.length > 0;
        const newPath = `${path} > ${child.desc_subcat}`;
        const newPathId = `${pathId}&${child.subcatid}`;
        return {
          id: newPathId,
          label: child.desc_subcat,
          path: newPath,
          pathId: newPathId,
          value: child.subcatid,
          children: hasChildren
            ? createChildren(newPath, newPathId, child.children)
            : [],
        };
      });
    };

    const { user } = this.state;

    if (user.idgroup !== undefined) {
      const retorno = await axios.get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfather_v2?groupid=${user.idgroup}`,
      );

      let array = [];
      let data = retorno.data;
      let categoryid = 0;
      if (Array.isArray(data) && data.length !== 0) {
        array = data
          .filter(
            (datum) =>
              Array.isArray(datum.children) && datum.children.length > 0,
          )
          .map((datum) => {
            const pathId = `${datum.categoryid}`;

            return {
              id: pathId,
              className: "dropdownd-three-childrens",
              label: datum.desc_category,
              path: datum.desc_category,
              pathId: pathId,
              value: datum.categoryid,
              children: createChildren(
                datum.desc_category,
                pathId,
                datum.children,
              ),
            };
          });
        this.props.mountTabulatorReduce(array);
      }
    }
  }

  render() {
    return <div />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MountTabulator);
